export function getCatalog(): string {
  return globalThis?.document?.documentElement?.getAttribute('catalog') ?? globalThis?.document?.documentElement?.lang;
}
export function getCatalogs(): string[] {
  return [];
}
